import api from '../api/axios';

// Payment Service Class
class PaymentService {
    // Get all subscription plans
    static async getPlans() {
        try {
            const response = await api.get('/payments/plans');
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get complete plan configuration
    static async getPlanConfiguration() {
        try {
            const response = await api.get('/payments/configuration');
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Initiate payment
    static async initiatePayment(subscriptionPlanId) {
        try {
            const response = await api.post(
                '/payments/initiate',
                { subscription_plan_id: subscriptionPlanId }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Check payment status
    static async checkPaymentStatus(orderId) {
        try {
            const response = await api.post(
                '/payments/status',
                { order_id: orderId }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Cancel payment
    static async cancelPayment(orderId) {
        try {
            const response = await api.post(
                '/payments/cancel',
                { order_id: orderId }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get payment history
    static async getPaymentHistory(page = 1, perPage = 15) {
        try {
            const response = await api.get(
                '/payments/history',
                {
                    params: { page, per_page: perPage }
                }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Handle return URL
    static async handleReturnUrl(orderId) {
        try {
            const response = await api.get(
                '/payments/hirehike/return',
                {
                    params: { order_id: orderId }
                }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get current subscription
    static async getCurrentSubscription() {
        try {
            const response = await api.get('/subscriptions/current');
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get subscription history
    static async getSubscriptionHistory(page = 1, perPage = 15) {
        try {
            const response = await api.get(
                '/subscriptions/history',
                {
                    params: { page, per_page: perPage }
                }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Cancel subscription
    static async cancelSubscription(reason = '') {
        try {
            const response = await api.post(
                '/subscriptions/cancel',
                { reason }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get subscription statistics
    static async getSubscriptionStats() {
        try {
            const response = await api.get('/subscriptions/stats');
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Check subscription status
    static async checkSubscriptionStatus() {
        try {
            const response = await api.get('/subscriptions/status');
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default PaymentService;
